import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import 'normalize.css'
import './assets/css/index.styl'
import './assets/iconfont/iconfont.css'

import { APPID } from 'api/config'

import Toast from '@/base/toast/index.js'
import Dialog from '@/base/dialog/index.js'

Vue.use(Toast)
Vue.use(Dialog)

Vue.config.productionTip = false

/* 创建首次链接之后进行Vue渲染， 避免并发造成PHPSESSID混乱错误 */
function vueRender(){
  function initVue() {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
  axios({
    url: '/activity/api.php?m=public&subm=front'
  }).then(() => {
      initVue();
  }).catch(() => {
      initVue();
  })
}

var zjrbCp = document.createElement('script')
zjrbCp.src = 'https://cdn-cp.tmuyun.com/jssdk/delta/zjrb-cp.delta.min.js'
document.body.appendChild(zjrbCp)
zjrbCp.onload = function () {
  if (CP && typeof CP.ready === 'function') {
    CP.ready({
      debug: false,
      wx_option: {
        debug: false,
        appid: APPID,
        method: 'getShareSign',
        redirect: location.href.split('#')[0],
        jsApiList: [
          'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocation'
        ],
      },
      ready: function (res) {
        console.log('zjrbCp.onload ready', res)
        sessionStorage.setItem('isClient', res.is_client)
        vueRender()
      },
      error: function (error) {
        console.log('zjrbCp.onload error', error)
        sessionStorage.setItem('isClient', error.client.is_client)
        if (error && error.code === 104) {
          vueRender()
        }
      }
    });
  }
}

